import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import * as UserActions from '../../actions/UserActions'
import * as Helper from '../../utils/Helper'
import Header from './parts/Header'
import Footer from '../after_login/parts/Footer'
import * as MyAPI from '../../utils/MyAPI'
import Alert from 'react-s-alert';

// EmailValidate
const EmailValidate = (props) => {

  let history = useNavigate();
  let navigate = useDispatch();

  // parameters
  let [loading, setLoading] = useState(false);
  let [emailMsg, setEmailMsg] = useState("処理中です...");

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    setLoading(true)

    try {

      // get params
      let urlSearchParams = new URLSearchParams(window.location.search);
      let params = Object.fromEntries(urlSearchParams.entries());
      let _token = params.token
      if (!_token) {
        throw Error("no token detected.")
      }

      // sign in with password
      let _results = await MyAPI.validateEmail({
        verification_token: _token,
      })
      if (_results.status !== 'success') {
        throw Error(_results.message)
      }

      setEmailMsg("メールアドレスの確認が取れました。ありがとうございます。右上のログインボタンより、ご登録のメールアドレスとパスワードでログインをお願いします。")

    } catch (err) {
      console.log("err:", err)

      setEmailMsg("メールアドレスの確認ができませんでした。")

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }

  return (
    <div>

      <div style={{
        backgroundColor: '#0C3966',
        height: 800,
      }}>

        {/* header */}
        <Header />


        <div>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="3" xs="12" />
            <Col md="6" xs="12" style={{ textAlign: 'left' }}>

              <div className="shadow2dp" style={{
                backgroundColor: '#ffffff',
                padding: 20,
              }}>

              <Row style={{
                marginTop: 10,
                marginBottom: 10,
              }}>
                <Col md="12" xs="12">
                  <span>
                    {emailMsg}
                  </span>
                </Col>
              </Row>
            </div>

            </Col>
            <Col md="3" xs="12" />
          </Row>
        </div>

      </div>

      {/* fooder */}
      <Footer />

    </div>
  )
}

export default EmailValidate
